import React from 'react';
import ProductcategoryHeader from '../ProductcategoryHeader';
import ProductcategoryContent from '../ProductcategoryContent';

const Productcategory = () => {
    return (
        <>
            <ProductcategoryHeader />
            <ProductcategoryContent />
        </>
    );
};

export default Productcategory;
